import React from "react";
import { LOGO_URL, GUN_BARREL_BG } from "@/lib/styles";

export default function StartScreen({ onStart }) {
  return (
    <div
      className="relative min-h-screen w-full flex flex-col items-center justify-between py-12 px-6"
      data-testid="start-screen"
    >
      {/* Background gun barrel */}
      <div
        className="absolute inset-0 opacity-25 pointer-events-none"
        style={{
          backgroundImage: `url(${GUN_BARREL_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050505]/40 to-[#050505] pointer-events-none" />

      {/* Top label */}
      <div className="relative z-10 fade-up text-center">
        <p
          className="font-display tracking-bond text-[#C9A961] text-xs sm:text-sm uppercase letter-reveal"
          data-testid="start-eyebrow"
        >
          A James Bond Photobooth Experience
        </p>
      </div>

      {/* Logo + CTA: one cluster, vertically centered so the button sits at
          mid-screen height on portrait kiosk displays */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-start pt-[4vh] w-full">
        <div className="flex flex-col items-center fade-up fade-up-d1">
          <img
            src={LOGO_URL}
            alt="Agent 100"
            className="w-auto max-w-[85%] pulse-slow"
            style={{ maxHeight: "24vh" }}
            data-testid="agent-100-logo"
          />
          <h1
            className="font-display text-[#C9A961] mt-8 text-3xl sm:text-4xl md:text-5xl tracking-bond letter-reveal"
            data-testid="event-title"
          >
            AGENT 100
          </h1>
          <p
            className="mt-3 text-[#A1A1AA] text-sm sm:text-base tracking-[0.3em] uppercase"
            data-testid="event-subtitle"
          >
            2 × 50 — Operacija stoletja
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center gap-6 fade-up fade-up-d3">
          <button
            onClick={onStart}
            data-testid="start-button"
            className="relative group overflow-hidden border border-[#C9A961] bg-transparent text-[#C9A961] hover:bg-[#C9A961]/10 transition-all duration-300 px-12 sm:px-20 py-6 sm:py-7 uppercase tracking-bond font-medium text-base sm:text-lg active:scale-[0.98]"
          >
            <span className="relative z-10">Pritisni za začetek</span>
            <span className="absolute inset-0 gold-sweep opacity-60" />
          </button>
          <p
            className="text-[#A1A1AA] text-xs tracking-[0.3em] uppercase"
            data-testid="start-hint"
          >
            Tvoja misija te čaka
          </p>
        </div>
      </div>
    </div>
  );
}
